import PropTypes from "prop-types";

const StockDisplay = ({stock}) => {
  if (!stock) return null;
  const {sku, lotNumber} = stock;
  return `SKU: ${sku || 'N/A'} (Lot: ${lotNumber || 'N/A'})`;
};

StockDisplay.propTypes = {
  stock: PropTypes.shape({
    sku: PropTypes.string,
    lotNumber: PropTypes.string,
  }),
};

export default StockDisplay;


// WEBPACK FOOTER //
// ./src/Product/StockDisplay.js